import { useEffect, useState } from "react";
import PageMeta from "../../components/common/PageMeta";
import MonthlyOrdersChart from "../../components/Transactions/MonthlyOrderChart";
import OrderMetrics from "../../components/Transactions/OrderMetrics";
import RecentOrders from "../../components/Transactions/RecentOrders";
import ExchangeModal from "../../components/ui/modal/ExhangeModal";
import { ExchangeIcon } from "../../icons";
import IndicativeRates from "../../components/Transactions/IndicativeRates";
import { useSidebar } from "../../context/SidebarContext";


export default function Home() {
  const [isExchangeModalOpen, setIsExchangeModalOpen] = useState(false);
  const [isDesktop, setIsDesktop] = useState(true);

  // Use the actual sidebar state from context
  const { isExpanded } = useSidebar();

  useEffect(() => {
    const mediaQuery = window.matchMedia("(min-width: 768px)");
    const handleResize = () => setIsDesktop(mediaQuery.matches);
    handleResize();
    mediaQuery.addEventListener("change", handleResize);
    return () => mediaQuery.removeEventListener("change", handleResize);
  }, []);

  const containerMaxWidthClass = isDesktop
    ? isExpanded
      ? "max-w-[1010px]"
      : "max-w-[1210px]"
    : "max-w-full";

  return (
    <>
      <PageMeta
        title="Home - Dashboard"
        description="This is our dashboard landing page"
      />

      <div className={`overflow-x-hidden w-full mx-auto ${containerMaxWidthClass}`}>
        <div className="w-full max-w-screen-2xl mx-auto mb-4">
          <IndicativeRates isSidebarExpanded={isExpanded} />
        </div>
      </div>

      <div className="grid grid-cols-12 gap-4 md:gap-6">
        <div className="col-span-12 xl:col-span-5">
          <button
            onClick={() => setIsExchangeModalOpen(true)}
            className="w-full h-full flex items-center justify-center p-6 rounded-2xl border border-gray-200 hover:border-blue-500 transition-colors duration-200 dark:border-gray-700 dark:hover:border-blue-600 bg-white dark:bg-gray-800"
          >
            <div className="text-center flex flex-col items-center justify-center">
              <h3 className="text-lg font-medium text-gray-900 dark:text-white">
                Currency Exchange
              </h3>
              <ExchangeIcon className="w-20 h-20" />
              <p className="mt-1 text-lg text-gray-900 dark:text-white">
                Click to make exchange
              </p>
            </div>
          </button>
        </div>

        <div className="col-span-12 space-y-6 xl:col-span-7">
          <OrderMetrics />
          <MonthlyOrdersChart />
        </div>

        <div className="col-span-12">
          <RecentOrders />
        </div>
      </div>

      <ExchangeModal
        isOpen={isExchangeModalOpen}
        onClose={() => setIsExchangeModalOpen(false)}
      />
    </>
  );
}
